import {PayoutWebModelOptions} from "@/components/forms/payout/payout-basics";
import {PaymentCodeEnum, PayoutWebModel} from "capitalist-shared/src/finance/payments";

interface CapitalistCardsTopupModelOptions extends PayoutWebModelOptions {
  card: any, ic_not_avail: boolean,
  kyc_rejected: boolean,
  warning_ic_not_avail: boolean,
  temp_problems_walleto: boolean,
  warning1: string,
  taxcode_required: boolean
  has_walleto: boolean
}

export class CapitalistCardsTopupModel extends PayoutWebModel {

  systemName = PaymentCodeEnum.CardsTopUp

  required = [
    'amount', 'description', 'fromAccount', 'cardId', 'taxCode',
    'verificationType',
  ]

  values: {
    fromAccount: string,
    cardId: string | number,
    taxCode: string,
    verificationType: string,
  } = {
    fromAccount: '',
    cardId: '', taxCode: '',
    verificationType: '',
  }

  options: CapitalistCardsTopupModelOptions = {
    ic_not_avail: false,
    kyc_rejected: false,
    warning_ic_not_avail: false,
    warning1: '',
    card: null,
    temp_problems_walleto: false,
    taxcode_required: false,
    has_walleto: false
  } as CapitalistCardsTopupModelOptions

  preselectCard(cardId: string | number) {
    if (cardId)
      this.values.cardId = cardId;
  }
}
